import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Elnätsbolagens sidor bor under /elnat/<slug>. Gamla URL:er pekas om. */
export const Route = createFileRoute("/elbolag/elnat/$slug")({
  beforeLoad: ({ params }) => permanentRedirect(`/elnat/${params.slug}`),
});
